import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/learn/collections/$slug',
}).lazy(() => import('./collections.$slug.lazy').then((d) => d.Route))
